import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../pages/AuthContext";
import { useLocation } from "react-router-dom";

export default function NavBar() {
  const location = useLocation();
  const { user, logout } = useAuth();
  const username = user?.username || "Guest";
  const [accountStatus, setAccountStatus] = useState("not_started");
  const showTracker = accountStatus !== "not_started";


    
  const getDiamondColor = (step) => {

      if (accountStatus === "onboarded") {
      if (step === 1) return "#ff4d4d"; // red
      if (step === 2) return "#ffd700"; // yellow
    }

      if (accountStatus === "trading") {
  return "#4dff88"; // green
    }

  return "#555"; // gray
    };
 

     useEffect(() => {
         const savedStatus = localStorage.getItem(`accountStatus_${username}`)
     if (savedStatus) {
    setAccountStatus(savedStatus)
    } else {
    setAccountStatus("not_started")
    }
    }, [location, username])

     if (!user) return null;

  return (
    <nav
      style={{
        background: "#000",
        color: "#fff",
        width: "100%",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "16px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Left: Logo */}
        <Link to="/" style={{ textDecoration: "none" }}>
          <img
            src="/spectra-logo.jpg"
            alt="Spectra Market Analyzer"
            style={{ height: 40, objectFit: "contain" }}
          />
        </Link>

        {/* Right: Username + buttons */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ opacity: 0.9, whiteSpace: "nowrap" }}>
            username = {username}
          </div>


             <Link to="/TradingAccountInformation" style={{ textDecoration: "none" }}>
           <div style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>


         <svg className="ultraCrystal" width="200" height="45" viewBox="0 0 250 60">

    <defs>

       <clipPath id="crystalClip">
      <polygon points="30,0 210,0 250,30 210,60 30,60 0,30"/>
       </clipPath>

       <linearGradient id="crystalBody" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#8af6ff"/>
        <stop offset="40%" stopColor="#39caff"/>
        <stop offset="100%" stopColor="#0066ff"/>
       </linearGradient>

       <linearGradient id="spectraSweep" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#00eaff" stopOpacity="0"/>
        <stop offset="40%" stopColor="#4fd8ff" stopOpacity="0.7"/>
        <stop offset="60%" stopColor="#7be3ff" stopOpacity="0.9"/>
        <stop offset="80%" stopColor="#00aaff" stopOpacity="0.7"/>
        <stop offset="100%" stopColor="#00eaff" stopOpacity="0"/>
       </linearGradient>

    </defs>

                    {/* Main Crystal Body */}
      <polygon
         points="30,0 210,0 250,30 210,60 30,60 0,30"
         fill="url(#crystalBody)"
         className="crystalGlow"
    />
      <polygon
         points="30,0 210,0 250,30 210,60 30,60 0,30"
         fill="none"
         stroke="#9be8ff"
         strokeWidth="1.2"
         opacity="0.7"
     />

   <rect
        x="-200"
        y="0"
        width="120"
        height="60"
        fill="url(#spectraSweep)"
        clipPath="url(#crystalClip)"  
      >
     <animate
        attributeName="x"
         from="-200"
         to="300"
         dur="6s"
         repeatCount="indefinite"
    />
           </rect>

                  {/* Crystal Facets */}
        <polygon points="30,0 70,30 30,60" fill="white" opacity="0.12"/>
        <polygon points="210,0 170,30 210,60" fill="white" opacity="0.12"/>

                    {/* Center Facet */}   
        <polygon points="70,0 170,0 170,60 70,60" fill="white" opacity="0.05"/>


         {/* Button Text or Progress Tracker */}

{showTracker ? (
  <>
    <polygon points="60,10 70,20 60,30 50,20" fill={getDiamondColor(1)} />
    <polygon points="120,10 130,20 120,30 110,20" fill={getDiamondColor(2)} />
    <polygon points="180,10 190,20 180,30 170,20" fill={getDiamondColor(3)} />

    <text x="60" y="40" textAnchor="middle" fill="white" fontSize="8">
      Created
    </text>

    <text x="120" y="40" textAnchor="middle" fill="white" fontSize="8">
      Submitted
    </text>

    <text x="180" y="40" textAnchor="middle" fill="white" fontSize="8">
      Trading
    </text>
  </>
) : (
  <text
    x="125"
    y="36"
    textAnchor="middle"
    fill="white"
    fontSize="15"
    fontWeight="bold"
    fontFamily="Arial"
  >
    Trading Account Information
  </text>
)}



     </svg>

     </div>
    </Link>
         

          <button
              type="button"
              onClick={logout}
              style={{
              background: "#444",
              color: "#fff",
              padding: "8px 14px",
              borderRadius: 6,
              border: "none",
              cursor: "pointer",
            }}
          >
            Sign out
          </button>
        </div>
      </div>
    </nav>
  );
}
